import React, { useEffect, useState } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ContentItem17 from '../../components/event/ContentItem17';

const Event202510_contentList = (props) => {
  const [list, setList] = useState();
  const { cp, eventCode } = props.childProps;
  console.log(cp);

  const _getContentList = async () => {
    // const eventCode = props.childProps.eventCode;
    const { apiUrl, loginId } = props;
    // let url
    // if(cp === 'aniplus') {
    //     url = `${apiUrl}/event_202404_content`
    // } else {
    //     url = `${apiUrl}/event_202404_content`
    // }
    // cp값으로 aniplus, animax 프로시져 별도 호출(backend 에서 설정)
    const result = await axios.post(`${apiUrl}/event_202510_content`, {
      params: {
        eventCode: eventCode,
        userid: loginId,
        cp: cp,
      },
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setList(result.data[0].listData);
    }
  };
  const _renderItem = () => {
    const contentList = list.map((item) => {
      return (
        <ContentItem17
          key={item.contentSerial}
          contentSerial={item.contentSerial}
          img={item.img}
          comment={item.comment}
          title={item.title}
          alramFlag={item.alram}
          cp={cp}
          king={item.king}
        />
      );
    });

    return contentList;
  };

  useEffect(() => {
    _getContentList();
  }, [cp, eventCode]);
  //   console.log(list);
  return (
    <ul className="list">{list && _renderItem()}</ul>

    // <ul>
    //   <li>{list && _renderItem()}</li>
    // </ul>
  );
};

export default shopContext(withRouter(Event202510_contentList));
